import React, { createContext, useCallback, useContext, useState } from "react";
import { SavedFilterFieldDescription } from "./savedFilterDescribe";

export interface SavedFilterScope {
    location: string;
    locationIdentifier?: string | null;
    getValues: () => Record<string, unknown>;
    applyValues: (values: Record<string, unknown>) => void;
    describe: (values: Record<string, unknown>) => SavedFilterFieldDescription[];
}

interface SavedFilterScopeContextValue {
    scope: SavedFilterScope | null;
    registerScope: (scope: SavedFilterScope) => void;
    unregisterScope: (scope: SavedFilterScope) => void;
}

const SavedFilterScopeContext = createContext<SavedFilterScopeContextValue | undefined>(undefined);

export const SavedFilterScopeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [scope, setScope] = useState<SavedFilterScope | null>(null);

    const registerScope = useCallback((next: SavedFilterScope) => {
        setScope(next);
    }, []);

    const unregisterScope = useCallback((current: SavedFilterScope) => {
        setScope((previous) => (previous === current ? null : previous));
    }, []);

    return (
        <SavedFilterScopeContext.Provider value={{ scope, registerScope, unregisterScope }}>
            {children}
        </SavedFilterScopeContext.Provider>
    );
};

export const useSavedFilterScope = (): SavedFilterScopeContextValue => {
    const context = useContext(SavedFilterScopeContext);
    if (!context) {
        throw new Error("useSavedFilterScope must be used within a SavedFilterScopeProvider");
    }
    return context;
};
